import { render } from "./VtoPageShare.vue?vue&type=template&id=55ab6e23"
import script from "./VtoPageShare.vue?vue&type=script&lang=js"
export * from "./VtoPageShare.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__